module.exports = __webpack_public_path__ + "static/media/purchasing.a93811a6.pdf";